import TimeReport from "./time-report"
import Resources from "../../resources/resources"
import Collection, {ModelInterface} from "../../data-structures/collection"
import FieldProto from "../../fields3/proto/field-proto"
import {SortDirection} from "../../data-structures/sort"
import {GroupedData} from "../../data-structures/group"
import groupByOperatorDeprecated from "../../data-structures/operators/group-by-deprecated"
import groupByPropertyOperator from "../../data-structures/operators/group-by-property"

const debug = false
// const debug = "TimeReportsCollection"

export default class TimeReportsCollection extends Collection<TimeReport> {

    static __CLASS_NAME = "TimeReportsCollection"

    constructor(models:TimeReport[]) {
        super(models);
    }

    static initFromResources(resources: Resources):TimeReportsCollection {
        return new TimeReportsCollection(resources.timeReports?.models as TimeReport[])
    }

    static initFromJson(data:any):TimeReportsCollection {

        // patch - in some stupid case we pass here not json data but collection
        // do not use "data?.constructor?.name === 'TimeReportsCollection'" obfuscation changes name
        if (data?.constructor?.__CLASS_NAME === TimeReportsCollection.__CLASS_NAME) {
            data = data.toJSON()
        }

        const collection = new TimeReportsCollection([])

        _.map(data, (record:JSONObject)=>{
            collection.add(new TimeReport(record))
        })

        return collection
    }

    getByTaskMessageId(taskMessageId:ID):TimeReport|undefined {

        return _.find(this.models, (timeReport)=>{
            return timeReport.taskMessageId === taskMessageId
        })

    }

    // return array of users who did time reports
    get userIds():ID[] {
        const usersSet = new Set<ID>()

        _.map(this.models, timeReport=>{
            usersSet.add(timeReport.userId)
        })

        return Array.from(usersSet)
    }

    get totalReportedTime() {
        let total = 0
        _.map(this.models, timeReport=>{
            if (timeReport.reportedTimeMinutes) {   // if prevents problems with undefined
                total += timeReport.reportedTimeMinutes
            }
        })

        return total
    }

    get costInternal() {

        let costInternal = 0

        _.map(this.models, (timeReport:TimeReport)=>{
            costInternal += timeReport.costInternal
        })

        return costInternal
    }

    get costExternal() {

        let total = 0

        _.map(this.models, timeReport=>{
            total += timeReport.costExternal
        })

        return total
    }

    get byUser(): Collection<TimeReportByUser> {
        const res = new Collection(_(this.models)
            .groupBy(t=>t.userId)
            .toPairs()
            .map(g=>new TimeReportByUser({
                userId              : g[0],
                reportedTimeMinutes : _.sum(_.map(g[1], (model:TimeReport)=>model.reportedTimeMinutes)),
                costInternal        : _.sum(_.map(g[1], (model:TimeReport)=>model.costInternal))
            }))
            .value())

        debug && console.log(debug, 'byUser', res)

        return res as unknown as Collection<TimeReportByUser>
    }

    public groupBy(field:FieldProto, sortDirection:SortDirection=SortDirection.ASC):GroupedData {
        const groups: GroupedData = groupByOperatorDeprecated(this.models, field, sortDirection) as GroupedData
        return groups
    }

    public groupByProperty(property:string, sortDirection:SortDirection=SortDirection.ASC):GroupedData {
        const groups: GroupedData = groupByPropertyOperator(this.models, property, sortDirection) as GroupedData
        return groups
    }

    clone() {
        return TimeReportsCollection.initFromJson(this.toJSON())
    }

    toJSON() {
        return _.map(this.models, (model:TimeReport)=>{ return model.toJSON()})
    }
}

const COST_DECIMALS = 3

export class TimeReportByUser implements ModelInterface {
    id                  : ID
    userId              : ID
    reportedTimeMinutes : number
    _costInternal       : number

    constructor(data:any) {
        this.id                     = data.userId
        this.userId                 = data.userId
        this.reportedTimeMinutes    = data.reportedTimeMinutes
        this._costInternal          = data.costInternal
    }

    get reportedTime() {
        return this.reportedTimeMinutes
    }

    get reportedTimeHours() {
        return this.reportedTimeMinutes / 60
    }

    get costInternal() {
        if (!this.reportedTimeMinutes) return 0

        return gd.utils.roundToDecimals(this._costInternal, COST_DECIMALS)
    }

    toJSON() {
        return {
            id                  : this.id,
            userId              : this.userId,
            reportedTimeMinutes : this.reportedTimeMinutes
        }
    }
}
